import React from 'react';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Modal } from '../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../CommonComponents/OPL/Modal/ModalHeader';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { AccountDistributionOrderOptionDTO } from './api/useAccountDistributionOptionsQuery';
import { IconButton } from '../CommonComponents/OPL/IconButton/IconButton';

interface AddAccountDistributionItemModalProps {
  isOpen: boolean;
  onClose(): void;
  options: AccountDistributionOrderOptionDTO[];
  onAdd(option: AccountDistributionOrderOptionDTO): void;
}

export const AddAccountDistributionItemModal = ({
  isOpen,
  onClose,
  options,
  onAdd,
}: AddAccountDistributionItemModalProps) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} aria={{ labelledby: 'modal-header' }}>
      <ModalHeader id="modal-header">Add account to distribution order</ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody>
        <Box display="flex" flexDirection="column" gridGap={8}>
          {options.map(option => (
            <Box
              key={option.id}
              css={({ theme }) => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: theme.space[8],
                border: `1px solid ${theme.colors.neutral[100]}`,
                borderRadius: theme.radii.medium,
                backgroundColor: theme.colors.neutral[50],
              })}
            >
              <div>
                <Text fontWeight={600}>{option.label}</Text>
                <Text fontSize="small">{option.taxStatus}</Text>
              </div>

              <IconButton
                icon="far fa-plus"
                variant="subtleInactive"
                onClick={() => onAdd(option)}
                aria-label={`Add ${option.label} to the list`}
              />
            </Box>
          ))}
        </Box>
      </ModalBody>
    </Modal>
  );
};
